'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* -----------  LOGIN  ------------------------------------ */

var LogInVerificationForm = _react2['default'].createClass({
    displayName: 'LogInVerificationForm',


    propTypes: {
        'errorMsg': _react2['default'].PropTypes.string,
        'redirectUrl': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'emailAddress': _react2['default'].PropTypes.string.isRequired,
        'rememberMe': _react2['default'].PropTypes.bool.isRequired,
        'phoneNumberLast2': _react2['default'].PropTypes.string.isRequired,
        'siteCode': _react2['default'].PropTypes.string.isRequired,
        'signature': _react2['default'].PropTypes.string.isRequired,
        'zendeskWidgetEnabled': _react2['default'].PropTypes.bool.isRequired
    },

    componentDidMount: function componentDidMount() {

        var self = this;
        var root = $(_reactDom2['default'].findDOMNode(this));
        var codeInput = root.find('.m-login--verification--code input');

        (0, _setTimeout2['default'])(function () {
            codeInput.focus();
        }, 500);

        $('.m-login--verification--links--modal').overlay({
            mask: 'rgba(100, 100, 100, 0.65)',
            speed: 0,
            onClose: function onClose() {
                self.hideHelp();
            }
        });
    },
    onSubmit: function onSubmit() {},
    resendCode: function resendCode(evt) {
        evt.preventDefault();
        var root = $(_reactDom2['default'].findDOMNode(this));
        $('input[name=\'resend\']', root).val('1');
        $('#login_form', root).submit();
    },
    enterRecoveryCode: function enterRecoveryCode(evt) {
        evt.preventDefault();
        var root = $(_reactDom2['default'].findDOMNode(this));
        $('.m-login--verification--instructions', root).hide();
        $('.m-login--verification--recovery', root).show();
        $('.m-login--verification--code input', root).attr('placeholder', 'Enter recovery code');
        this.hideHelp();
    },
    contactSupport: function contactSupport(evt) {
        evt.preventDefault();
        this.hideHelp();
        if (this.props.zendeskWidgetEnabled) {
            zE(function () {
                zE.activate({ hideOnClose: true });
            });
        } else {
            UserVoice.showLightbox();
        }
    },
    showHelp: function showHelp(evt) {
        evt.preventDefault();
        var root = $(_reactDom2['default'].findDOMNode(this));
        $('.m-login--verification--links--modal', root).overlay().load();
        $('#problemLink', root).hide();
    },
    hideHelp: function hideHelp() {
        var root = $(_reactDom2['default'].findDOMNode(this));
        $('.m-login--verification--links--modal', root).overlay().close();
        $('#problemLink', root).show();
    },
    getPhoneNumberLast2Safe: function getPhoneNumberLast2Safe() {
        //Make sure we're only getting 2 characters. Since we're getting the prop from query params, it prevents text injection. (DEV-2313)
        return this.props.phoneNumberLast2.substr(0, 2);
    },
    render: function render() {

        var targetUrl = _hfReactHelper2['default'].urlHelper('account/logInVerification', this.props.siteCode);
        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
        var err = this.props.errorMsg ? _react2['default'].createElement(
            'p',
            { className: 'm-login--verification--error' },
            this.props.errorMsg
        ) : null;

        return _react2['default'].createElement(
            'div',
            { className: 'm-login is-verification' },
            _react2['default'].createElement(
                'form',
                { ref: 'login_form', className: 'm-login--form', id: 'login_form', action: targetUrl, method: 'POST' },
                _react2['default'].createElement(
                    'div',
                    null,
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12' },
                        _react2['default'].createElement(
                            'h3',
                            { className: 'm-login--verification--title' },
                            '2-step account verification'
                        )
                    ),
                    _react2['default'].createElement(
                        'p',
                        { className: 'columns small-12 l-text-centered m-login--verification--instructions' },
                        'We just sent you a text message to (***) ***-**',
                        this.getPhoneNumberLast2Safe(),
                        ' with your code. Please enter the code to log in.'
                    ),
                    _react2['default'].createElement(
                        'p',
                        { className: 'columns small-12 l-text-centered m-login--verification--recovery' },
                        'Enter the recovery code that was given to you when you enabled 2-Factor Authentication.\xA0',
                        _react2['default'].createElement(
                            'b',
                            null,
                            'The code will become void and 2-Factor Authentication will be disabled.'
                        )
                    ),
                    _react2['default'].createElement('input', { type: 'hidden', name: 'verification[last2]', value: this.getPhoneNumberLast2Safe() }),
                    _react2['default'].createElement('input', { type: 'hidden', name: 'verification[email_address]', value: this.props.emailAddress }),
                    _react2['default'].createElement('input', { type: 'hidden', name: 'verification[rm]', value: this.props.rememberMe ? '1' : '0' }),
                    _react2['default'].createElement('input', { type: 'hidden', name: 'verification[redirect_url]', value: this.props.redirectUrl }),
                    _react2['default'].createElement('input', { type: 'hidden', name: 'verification[signature]', value: this.props.signature }),
                    _react2['default'].createElement('input', { type: 'hidden', name: 'resend', value: '0' }),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-login--verification--code' },
                        _react2['default'].createElement('input', { type: 'text',
                            name: 'verification[code]',
                            className: 'm-login--text-input',
                            placeholder: 'Enter code',
                            maxLength: '6',
                            tabIndex: tabOffset }),
                        err
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'small-10 small-offset-1 text-center' },
                        _react2['default'].createElement(_button2['default'], { onClick: this.onSubmit,
                            type: 'submit',
                            buttonClass: '',
                            buttonText: 'VERIFY',
                            buttonColor: 'grasshopper',
                            buttonHoverColor: 'castle-rock',
                            buttonTabIndex: tabOffset + 1 })
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-login--verification--links' },
                        _react2['default'].createElement(
                            'a',
                            { href: 'javascript:;', id: 'problemLink', onClick: this.showHelp },
                            'Problems receiving your code?'
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-login--verification--links--modal form-overlay' },
                            _react2['default'].createElement(
                                'div',
                                { className: 'm-login--verification--links--modal--title' },
                                'Try one of these methods'
                            ),
                            _react2['default'].createElement(
                                'a',
                                { href: 'javascript:;', id: 'resendCodeLink', className: 'first small-4 column', onClick: this.resendCode },
                                'Resend me the code'
                            ),
                            _react2['default'].createElement(
                                'a',
                                { href: 'javascript:;', id: 'recoveryLink', className: 'middle small-4 column', onClick: this.enterRecoveryCode },
                                'Use my recovery code'
                            ),
                            _react2['default'].createElement(
                                'a',
                                { href: 'javascript:;', id: 'helpLink', className: 'last small-4 column', onClick: this.contactSupport },
                                'Contact support for help'
                            )
                        )
                    )
                )
            )
        );
    }
});

module.exports = LogInVerificationForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/login-verification-form.jsx
 ** module id = 882
 ** module chunks = 0
 **/